import { PROCESES, CREATE_PROCESS } from './actionTypes';
import axios from '../../utils/axios';
import progressUpdate from '../progress';
import { hideSnackbar, showSnackbar } from '../snackbar';

const getProceses = page => (dispatch) => {
  dispatch({ type: `${PROCESES}_REQUEST` });
  axios.get(`multiple_uploads?page=${page}`, { data: {} })
    .then(({ data: { multiple_uploads, total_multiple_uploads, total_pages } }) =>
      dispatch({
        type: `${PROCESES}_SUCCESS`,
        proceses: multiple_uploads,
        total: total_multiple_uploads,
        pages: total_pages,
      }))
    .catch(() => dispatch({ type: `${PROCESES}_ERROR`, error: 'Error al traer los procesos' }));
};

const createProcess = process => (dispatch) => {
  dispatch({ type: `${CREATE_PROCESS}_REQUEST` });
  dispatch(progressUpdate(0));
  dispatch(hideSnackbar());
  axios.post('multiple_uploads', process, {
    headers: {
      'Content-Type': 'multipart/form-data',
    },
    onUploadProgress: (progressEvent) => {
      const percentCompleted = Math.round((progressEvent.loaded * 100) / progressEvent.total);
      dispatch(progressUpdate(percentCompleted));
    },
  })
    .then(() => {
      dispatch(getProceses(1));
      dispatch(showSnackbar('Los recibos fue cargados correctamente.', 'success'));
      dispatch({ type: `${CREATE_PROCESS}_SUCCESS` });
    })
    .catch((error) => {
      dispatch(showSnackbar('Ha ocurrido un error al cargar los recibos', 'error'));
      dispatch({ type: `${CREATE_PROCESS}_ERROR`, error });
    });
};

export {
  getProceses,
  createProcess,
};



// WEBPACK FOOTER //
// ./src/actions/proceses/index.js